import '@barev/ui/styles.css';
import './app.css';
import { ApiProvider, loadTextOverrides, initTelegram, ToastProvider } from '@barev/web';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { authHeader, consumeLoginLink, hasAuth } from './auth.ts';

initTelegram();
// названия и описания услуг, изменённые в админке
void loadTextOverrides();

// в браузере: ссылка из бота ?login=… меняется на токен до первого запроса
void consumeLoginLink().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ApiProvider headers={authHeader}>
        <ToastProvider>
          <App hasInitData={hasAuth()} />
        </ToastProvider>
      </ApiProvider>
    </StrictMode>,
  );
});
